import { BreakpointArray } from '@thg-commerce/gravity-theme'

type HorizontalAlignment = 'left' | 'center' | 'right'

export interface PaddingInterface {
  top: BreakpointArray<number>
  right: BreakpointArray<number>
  bottom: BreakpointArray<number>
  left: BreakpointArray<number>
}

export interface MarginInterface {
  top: BreakpointArray<number | string>
  right: BreakpointArray<number | string>
  bottom: BreakpointArray<number | string>
  left: BreakpointArray<number | string>
}

export interface GutterPaddingInterface extends PaddingInterface {
  gap: number
}
export interface EditorialItemThemeInterface {
  andromedaEditorial: {
    gutterPadding: GutterPaddingInterface
    contentGutterPadding: PaddingInterface
  }
  twoItemEditorial: {
    horizontalAlignment: HorizontalAlignment
    gutterPadding: GutterPaddingInterface
    contentGutterPadding: PaddingInterface
  }
  threeItemEditorial: {
    horizontalAlignment: HorizontalAlignment
    gutterPadding: GutterPaddingInterface
    contentGutterPadding: PaddingInterface
  }
  editorialWithFeature: {
    horizontalAlignment: HorizontalAlignment
    gutterPadding: GutterPaddingInterface
    contentGutterPadding: PaddingInterface
  }
  threeItemEditorialSubtitleBG: {
    gutterPadding: GutterPaddingInterface
    contentGutterPadding: PaddingInterface
  }
  fourItemEditorial: {
    gutterPadding: GutterPaddingInterface
    contentGutterPadding: PaddingInterface
  }
}

// TODO: REBUILD-5407: Add this to Artemis so that it can
//       changed on a site-by-site basis
export const EditorialItemTheme: EditorialItemThemeInterface = {
  andromedaEditorial: {
    gutterPadding: {
      top: [1, 2],
      right: [2, 2, 4],
      bottom: [1, 2],
      left: [2, 2, 4],
      gap: 2,
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
  twoItemEditorial: {
    horizontalAlignment: 'center',
    gutterPadding: {
      top: [1, 2],
      right: [2, 2, 4],
      bottom: [1, 2],
      left: [2, 2, 4],
      gap: 2,
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
  threeItemEditorial: {
    horizontalAlignment: 'center',
    gutterPadding: {
      top: [1, 2],
      right: [2, 2, 4],
      bottom: [1, 2],
      left: [2, 2, 4],
      gap: 2,
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
  editorialWithFeature: {
    horizontalAlignment: 'center',
    gutterPadding: {
      top: [1, 2],
      right: [2, 2, 4],
      bottom: [1, 2],
      left: [2, 2, 4],
      gap: 2,
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
  threeItemEditorialSubtitleBG: {
    gutterPadding: {
      top: [1, 2],
      right: [2, 2, 4],
      bottom: [1, 2],
      left: [2, 2, 4],
      gap: 2,
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
  fourItemEditorial: {
    gutterPadding: {
      top: [1, 2],
      right: [2, 2, 4],
      bottom: [1, 2],
      left: [2, 2, 4],
      gap: 2,
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
}
